module.exports = __webpack_public_path__ + "media/113.bfc1786f.wav";